console.log("[DynamicFilters] Booting Dynamic Filters script…");

// STEP 1 — Load saved menu data
let dynamicMenuData = [];
try {
  dynamicMenuData = JSON.parse(sessionStorage.getItem("dynamicMenuData") || "[]");
  console.log("[DynamicFilters] Loaded menu data:", dynamicMenuData.length);
} catch (e) {
  console.error("[DynamicFilters] JSON parse error:", e);
  dynamicMenuData = [];
}

// STEP 2 — Render dynamic filters
function renderDynamicMenuIntoSidebar() {
  const sidebar = document.querySelector("#SidebarDynamicFilters");
  if (!sidebar) return console.warn("[DynamicFilters] SidebarDynamicFilters missing");

  // Prevent double render
  if (sidebar.dataset.rendered === "1") return;

  let html = "";

  dynamicMenuData.forEach(group => {
    html += `<div class="dynamic-group"><p class="menu-title">${group.title}</p>`;
    group.items.forEach(item => {
      html += `
        <a class="dynamic-filter-item"
           data-group="${item.group}"
           data-value="${item.value}"
           href="${item.url}">
          ${item.label}
        </a>`;
    });
    html += `</div>`;
  });

  sidebar.innerHTML = html;
  sidebar.dataset.rendered = "1";

  console.log("[DynamicFilters] Rendered successfully.");

  highlightActiveCategory();
}

// STEP 3 — Highlight active category
function highlightActiveCategory() {
  const links = document.querySelectorAll("#SidebarDynamicFilters .dynamic-filter-item");
  const qs = window.location.search;

  links.forEach(link => {
    if (qs.includes(encodeURIComponent(link.dataset.value))) {
      link.classList.add("active");
    }
  });
}

// STEP 4 — Wait for sidebar hydration (Prestige loads async)
function waitForSidebar() {
  const wrapper = document.querySelector(".facets-sidebar__wrapper");
  if (!wrapper || wrapper.offsetHeight === 0) {
    return setTimeout(waitForSidebar, 150);
  }

  console.log("🔥 Sidebar READY. Injecting dynamic filters...");
  renderDynamicMenuIntoSidebar();
}

waitForSidebar();